export * from '@primeuix/themes/aura/accordion';
export { default } from '@primeuix/themes/aura/accordion';
